import { render, staticRenderFns } from "./CreateSalesReceipt.vue?vue&type=template&id=53a2854f&scoped=true"
import script from "./CreateSalesReceipt.vue?vue&type=script&lang=js"
export * from "./CreateSalesReceipt.vue?vue&type=script&lang=js"
import style0 from "./CreateSalesReceipt.vue?vue&type=style&index=0&id=53a2854f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2854f",
  null
  
)

export default component.exports